import { onError } from "./onError";

/**
 * Универсальная функция для сохранения данных в localStorage
 */
export const saveToStorage = <T>(key: string, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    onError(error);
  }
};

/**
 * Универсальная функция для загрузки данных из localStorage
 */
export const loadFromStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (error) {
    onError(error);
    return defaultValue;
  }
};
